// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesHomePage_container__3FSSR","titleContent":"FeaturesHomePage_titleContent__3tvel"};